import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getFlowVasActionAsync } from '../redux/actions/flowVasAction'

export const useFlowVas = () => {
  const { flowVasState } = useSelector((state: RootState) => state.flowVas)

  const dispatch = useDispatch()

  const getFlowVas = () => {
    dispatch(getFlowVasActionAsync())
  }

  return { flowVasState, getFlowVas }
}
